export default class Image {
  readonly url: string
  readonly thumb: string
  readonly medium: string
  readonly card: string

  constructor(data: { [key: string]: any }) {
    this.url = data.url
    this.thumb = data.thumb
    this.medium = data.medium
    this.card = data.card
  }
}
